import JShelmet from '../assets/cards/js.png'
import  Figmahelmet from '../assets/cards/figma.png'
import  helmetCSS from '../assets/cards/css.png'
import  helmetHTML from '../assets/cards/html.png'
import  helmetJSX from '../assets/cards/react.png'
import  helmetSASS from '../assets/cards/Sass.png'
import helmetCsharp from '../assets/cards/csharp.png'
import helmetDocker from '../assets/cards/docker.webp'
import helmetAngular from '../assets/cards/angular.png'
import helmetNode from '../assets/cards/nodejs.png'
import helmetTypescript from '../assets/cards/typescript.png'
import helmetGit from '../assets/cards/git.png'
import helmetMongo from '../assets/cards/mongodb.png'

let lenguages=[
    {
        "id": 1,
        "name": "Javascript",
        "image": JShelmet
    },
    {
        "id": 2,
        "name": "Figma",
        "image": Figmahelmet
    },
    {
        "id": 3,
        "name": "HTML5",
        "image": helmetHTML
    },
    {
        "id": 4,
        "name": "CSS",
        "image": helmetCSS
    },
    {
        "id": 5,
        "name": "React",
        "image": helmetJSX
    },
    {
        "id": 6,
        "name": "SASS",
        "image": helmetSASS
    },
    {
        "id": 7,
        "name": "Csharp",
        "image": helmetCsharp
    },
    {
        "id": 8,
        "name": "Docker",
        "image": helmetDocker
    },
    { 
        "id": 9,
        "name": "Angular",
        "image": helmetAngular
    },
    {
        "id": 10,
        "name": "NodeJS",
        "image": helmetNode
    },
    {
        "id": 11,
        "name": "Typescript",
        "image": helmetTypescript
    },
    {
        "id": 12,
        "name": "Git",
        "image": helmetGit
    },
    {
        "id": 13,
        "name": "MongoDB",
        "image": helmetMongo
    }
]

export default lenguages